//// filepath: /Users/rodrigo.mendoza/personal/endocomunidad/frontend/src/components/SEO.tsx
import React from "react";
import { Helmet } from "react-helmet";

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
}

export const SEO: React.FC<SEOProps> = ({
    title = "EndoComunidad | Información sobre Endometriosis",
    description = "EndoComunidad ofrece información, artículos y recursos sobre la endometriosis para pacientes y profesionales.",
    keywords = "endocomunidad, endometriosis, endometriosis uruguay, dolor menstrual, menstruación, salud, información, recursos, artículos",
}) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
        </Helmet>
    );
};